import React from 'react';
import './PageHeader.css';

export default function PageHeader({ icon: Icon, title, subtitle, greeting, action, className = '' }) {
  return (
    <div className={`ph ${className}`}>
      <div className="ph-left">
        {Icon && (
          <div className="ph-icon">
            {typeof Icon === 'function'
              ? <Icon size={22} strokeWidth={1.75} />
              : Icon?.$$typeof
                ? <Icon size={22} strokeWidth={1.75} />
                : Icon
            }
          </div>
        )}
        <div className="ph-text">
          {greeting && <p className="ph-greeting">{greeting}</p>}
          <h1 className="ph-title">{title}</h1>
          <div className="ph-accent" />
          {subtitle && <p className="ph-subtitle">{subtitle}</p>}
        </div>
      </div>
      {action && <div className="ph-action">{action}</div>}
    </div>
  );
}
